import App from "App";
// import { BrowserRouter } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import { MaterialUIControllerProvider } from "context";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "store";
import FusionCharts from "fusioncharts";
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(
  "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-075547}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Sohum_Tech_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Analytics}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Analytics}_need_to_be_licensed___{Analytics}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{21_March_2026}____[v3]_[0102]_MTc3NDA1MTIwMDAwMA==91f29aa3d4f3b7917436c6a9a2c7e9ae"
);

FusionCharts.options.license({
  key: "6aE2itzG1C3C8B3F3F3D2A2C2H1C8B7B5E-11acE3E3G2sA4B2C2feI-8D1H4B3zD-13mD1D3G4nvrB9D2C6E2C4B1I4F1A9C11A5uD-11C-9A2I3NC5qD-17jD2E2F1H-8jC2a1A5C7fg1qH4G1B8C2D2C2F2C5F1G1G1A11D9E4i==",
  creditLabel: false,
});

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <HashRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </MaterialUIControllerProvider>
  </HashRouter>
);
